module.exports = __webpack_public_path__ + "static/media/learning11StepM.f44f115a.png";